import { useEffect, useState } from 'react'

export function useFileSelection({ files, resetKey, initialIds = [] }) {
  const [selectedIds, setSelectedIds] = useState(() => new Set(initialIds))

  useEffect(() => {
    setSelectedIds(new Set(initialIds))
  }, [resetKey]) // initialIds belongs to the history entry named by resetKey

  useEffect(() => {
    if (!Array.isArray(files)) return
    const present = new Set(files.map(f => f.id))
    setSelectedIds(prev => {
      const kept = new Set([...prev].filter(id => present.has(id)))
      return kept.size === prev.size ? prev : kept
    })
  }, [files])

  function toggle(id) {
    setSelectedIds(prev => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })
  }

  function toggleAll(shownIds) {
    setSelectedIds(prev => {
      if (shownIds.length > 0 && shownIds.every(id => prev.has(id))) {
        const next = new Set(prev)
        for (const id of shownIds) next.delete(id)
        return next
      }
      return new Set(shownIds)
    })
  }

  function clear() {
    setSelectedIds(new Set())
  }

  const isSelected = id => selectedIds.has(id)
  const allSelected = shownIds => shownIds.length > 0 && shownIds.every(id => selectedIds.has(id))
  const someSelected = shownIds => shownIds.some(id => selectedIds.has(id))

  return { selectedIds, toggle, toggleAll, clear, isSelected, allSelected, someSelected }
}
